/**
 * Error Display Component
 * Displays error state with optional retry action
 */

import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  message,
  onRetry
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="max-w-md w-full p-6 border-destructive/20">
        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-destructive/10 rounded-full mb-4">
          <AlertCircle className="w-6 h-6 text-destructive" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2 text-center">Error</h3>
        <p className="text-sm text-muted-foreground mb-4 text-center">{message}</p>
        {onRetry && (
          <Button
            onClick={onRetry}
            variant="destructive"
            className="w-full"
          >
            Try Again
          </Button>
        )}
      </Card>
    </div>
  );
};
